<template>
  <OutOfStock
    v-if="isOutOfStock && productResponse"
    :alternative="outOfStockAlternative"
    :breadcrumb="breadcrumbResponse?.breadcrumb ?? []"
    class="ps-24 md:ps-0"
    :is-alternative-loading="isOutOfStockAlternativeLoading"
    :product="productResponse"
    :ratings="ratesResponse"
  />
</template>

<script setup lang="ts">
import OutOfStock from '~/scopes/product-core/components/presentationals/OutOfStock/OutOfStock.vue'
import { useFetchBreadcrumb } from '~/scopes/product-core/composables/useFetch/useFetchBreadcrumb/useFetchBreadcrumb'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'
import { useOutOfStockAlternative } from '~/scopes/product-core/composables/useOutOfStockAlternative/useOutOfStockAlternative'

const { isOutOfStock } = useFetchPickers()
const { data: productResponse } = useFetchProduct()
const { data: breadcrumbResponse } = useFetchBreadcrumb()
const { data: ratesResponse } = useFetchReviewsSummary()
const { outOfStockAlternative, isOutOfStockAlternativeLoading } =
  useOutOfStockAlternative()
</script>
